export default __webpack_public_path__ + "cf82a53cc573e46a08aa4ab56b6a08ab.png";